import { Box, TextField, Typography } from "@mui/material";
import React from "react";

export default function IBanNumberInput() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        border: "1px solid gray",
        paddingX: "8px",
        borderRadius: "8px",
      }}
    >
      <TextField
        placeholder="شبا خود را وارد کنید"
        size="small"
        sx={{
          flex: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-input": {
            border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-root": {
            border: "none !important",
            outline: "none !important",
          },
          border: "none",
        }}
      />
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "600",
          color: "primary.main",
        }}
      >
        IR
      </Typography>
    </Box>
  );
}
